// Angular
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes, CanLoad, Route } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatIconRegistry, MatButtonModule, MatIconModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
// HammerJS
import 'hammerjs';
// Fuse
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { fuseConfig } from 'app/fuse-config';
import { FakeDbService } from 'app/fake-db/fake-db.service';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api'; // For FakeDb/Fake Api
// Environment
import { environment } from 'environments/environment';
// Firebase
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule, FirestoreSettingsToken } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
// Core
import { CoreModule } from 'app/core/core.module';
// Guards
import { LoadAppsGuard } from 'app/core/guards/load-apps.guard';
// Modules
import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';

const firebaseConfig = environment.firebaseConfig;

const appRoutes: Routes = [
    {
        path        : 'auth',   
        loadChildren: 'app/main/authentication/authentication.module#AuthenticationModule',
    },
    {
        path        : 'profile',
        loadChildren: 'app/main/profile/profile.module#ProfileModule',
        canLoad     : [LoadAppsGuard],
    },
    {
        path        : 'apps',
        loadChildren: 'app/main/apps/apps.module#AppsModule',
        canLoad: [LoadAppsGuard]
    },
    {
        path        : 'error',
        loadChildren: 'app/main/errors/errors.module#ErrorsModule',
    },
    {
        path        : '',
        redirectTo  : '/profile',
        pathMatch   : 'full'
    },
    {
        path      : '**',
        redirectTo: 'app/main/error/404'
    }
];

@NgModule({
    declarations: [
        AppComponent
    ],
    providers   : [
        LoadAppsGuard,
        { 
            provide: FirestoreSettingsToken, 
            useValue: {} 
        }
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(
            appRoutes,
            // { enableTracing: true } // <-- debugging purposes only
        ),

        TranslateModule.forRoot(),
        // FakeDbService 
        InMemoryWebApiModule.forRoot(FakeDbService, {
            delay             : 0,
            passThruUnknownUrl: true
        }),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,

        // Firebase & AngularFire
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFirestoreModule, // imports firebase/firestore, only needed for database features
        AngularFireAuthModule, // imports firebase/auth, only needed for auth features

        // Core
        CoreModule
    ],
    exports     : [
        RouterModule
    ],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
    constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer){
        matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('assets/mdi.svg')); // Or whatever path you placed mdi.svg at
    }
}
